import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { GroupFragment } from 'api';
import { generateLink } from 'Links';

interface IProps {
  group: GroupFragment;
}

const useStyles = makeStyles(theme => ({
  type: {
    color: theme.palette.secondary.main,
  },
}));

const GroupResult: FC<IProps> = ({ group }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Fragment>
      <Typography variant="subtitle2">
        <span className={classes.type}>{t('search:group')} </span>
        <Link title={group.title} component={generateLink(`/group/${group.id}`)}>
          {group.title}
        </Link>
      </Typography>
      <Typography color="textSecondary">
        {t('components:xMember', { count: group.follower_count })}
        {group.department_title && t('search:department', { title: group.department_title })}
        {group.location_title && t('search:location', { title: group.location_title })}
      </Typography>
    </Fragment>
  );
};

export default GroupResult;
